









































































































import Vue from 'vue';
import he from 'he';
import { BCard, BCardTitle, BLink, BButton, BRow, BCol, BImg, BImgLazy, BBadge } from 'bootstrap-vue';
import { Post } from '@/common/types';

export default Vue.extend({
  props: {
    post: {
      type: Object as () => Post,
    },
  },
  data: () => ({
    played: false,
    failed: false,
  }),
  computed: {
    decodedTitle(): string {
      return he.decode(this.post.title);
    },
  },
  methods: {
    onClickPlay() {
      this.played = true;
      this.$nextTick(() => {
        const videoPlayer = this.$refs.video as HTMLVideoElement;
        videoPlayer.play();
      });
    },
    visibilityChanged(isVisible: boolean) {
      if (!isVisible) {
        const videoPlayer = this.$refs.video as HTMLVideoElement;
        videoPlayer.pause();
      }
    },
    sharePost() {
      const data = {
        title: 'Ninegag via Mblonyox',
        text: this.post.title,
        url: window.location.origin + '/post/' + this.post.id,
      };
      const navigator = window.navigator as any;
      if (navigator.share) {
        navigator.share(data);
      } else {
        this.$root.$emit('share::post', data);
      }
    },
  },
  components: { BCard, BCardTitle, BLink, BButton, BRow, BCol, BImg, BImgLazy, BBadge },
});
